import * as routes from 'pages/routes';
import * as authService from 'resources/auth/auth.service';
import { useEffect } from 'react';

export default function useProcessEmailLink({ setIsLoading }) {
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;

    const { accessToken, refreshToken, type, error, errorDescription } = parseHash(hash);

    const isLinkValid = accessToken && refreshToken && (type === 'invite' || type === 'recovery' || type === 'magiclink');
    if (isLinkValid) {
      const signInAndReload = async () => {
        setIsLoading(true);
        await authService.signInWithRefreshToken({ refreshToken });
        setIsLoading(false);

        removeHashAndReloadPage();
      };

      signInAndReload();
    }

    const isLinkExpired = error && errorDescription === 'Email link is invalid or has expired';
    if (isLinkExpired) {
      const linkSource = getLinkSource();
      window.location.href = `${routes.path.expiredLink}${linkSource ? `?source=${linkSource}` : ''}`;
    }
  }, [setIsLoading]);
}

function getLinkSource() {
  const url = window.location.href;
  if (url.includes(routes.path.signUpInvitee)) return 'invite';
  if (url.includes(routes.path.resetPassword)) return 'reset-password';
  if (url.includes(routes.path.account)) return 'upgrade-now';

  return '';
}

function removeHashAndReloadPage() {
  // remove hash and reload the page to make sure the auth cookie is set after sign in
  const urlWithoutHash = window.location.href.split('#')[0];
  history.replaceState(null, null, urlWithoutHash);
  window.location.reload();
}

function parseHash(hash) {
  const params = new URLSearchParams(hash.split('#')[1]);
  const accessToken = params.get('access_token');
  const refreshToken = params.get('refresh_token');
  const type = params.get('type');
  const error = params.get('error');
  const errorDescription = params.get('error_description');

  return { accessToken, refreshToken, type, error, errorDescription }
}
